import { ComponentType } from "react";
import { ExternalToast, toast } from "sonner";
import cx from "classnames";
import { Button } from "@/ui";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";

export type ToastWithoutAction = {
    icon?: ComponentType;
    actionText?: undefined;
    action?: undefined;
    href?: undefined;
};
export type ToastWithAction = {
    icon?: ComponentType;
    actionText: string;
    action: Function;
    href?: undefined;
};
export type ToastWithLink = {
    icon?: ComponentType;
    actionText: string;
    action?: undefined;
    href: string;
};

export type ToastAction = ToastWithoutAction | ToastWithAction | ToastWithLink;

export const notifySuccess = function (
    message: string,
    data: ToastAction = {},
    extras?: ExternalToast,
) {
    toast.success(
        <ToastContents
            status="success"
            message={message}
            icon={data.icon ?? FaCheckCircle}
            action={data.action}
            actionText={data.actionText}
            href={data.href}
        />,
        extras,
    );
};
export const notifyError = function (
    message: string,
    data: ToastAction = {},
    extras?: ExternalToast,
) {
    toast.error(
        <ToastContents
            status="error"
            message={message}
            icon={data.icon ?? FaTimesCircle}
            action={data.action}
            actionText={data.actionText}
            href={data.href}
        />,
        extras,
    );
};
export const notifyInfo = function (
    message: string,
    data: ToastAction = {},
    extras?: ExternalToast,
) {
    toast.info(
        <ToastContents
            status="info"
            message={message}
            icon={data.icon}
            action={data.action}
            actionText={data.actionText}
            href={data.href}
        />,
        extras,
    );
};

type Status = "success" | "error" | "info";

const ToastContents = ({
    message,
    icon: Icon,
    actionText,
    action,
    status,
    href,
}) => {
    return (
        <div className="flex flex-row items-center p-4 gap-x-4">
            {!!Icon && (
                <Icon
                    className={cx(
                        "w-5 h-5",
                        status === "success" && "text-green-140",
                        status === "error" && "text-red-100",
                        status === "info" && "text-primary-100",
                    )}
                />
            )}

            <span className="text-lato flex-1">{message}</span>

            {!!(action || href) && (
                <Button
                    variant="link"
                    href={href}
                    onClick={action}
                    className="w-max">
                    {actionText}
                </Button>
            )}
        </div>
    );
};
